import { render, staticRenderFns } from "./assessmentSet.vue?vue&type=template&id=7fb4f082&scoped=true&"
import script from "./assessmentSet.vue?vue&type=script&lang=js&"
export * from "./assessmentSet.vue?vue&type=script&lang=js&"
import style0 from "./assessmentSet.vue?vue&type=style&index=0&id=7fb4f082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4f082",
  null
  
)

export default component.exports